import { useQuery } from '@apollo/client/react';
import { useMemo } from 'react';
import { GET_PROJECT_WITH_CRITICAL_PERIODS } from '../graphql/criticalPeriodQueries';
import { CriticalPeriodType } from 'domain/shared/newProject/team/types';
import { AccessInfo } from 'domain/shared/newProject';

interface ProjectCriticalPeriodsResponse {
  baseProject: {
    id: string | number;
    criticalPeriods: CriticalPeriodType[];
    accessInfo: AccessInfo;
  };
}

export const useCriticalPeriodById = (projectId: string | number | undefined, criticalPeriodId: string | undefined) => {
  const { data, loading, error, refetch } = useQuery<ProjectCriticalPeriodsResponse>(
    GET_PROJECT_WITH_CRITICAL_PERIODS,
    {
      variables: { projectId: projectId?.toString() },
      skip: !projectId || !criticalPeriodId,
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
    },
  );

  const criticalPeriod = useMemo(() => {
    if (!data?.baseProject?.criticalPeriods || !criticalPeriodId) return null;
    return (
      data.baseProject.criticalPeriods.find(
        (projectCriticalPeriod: CriticalPeriodType) => projectCriticalPeriod.id === criticalPeriodId,
      ) || null
    );
  }, [data, criticalPeriodId]);

  return {
    criticalPeriod,
    accessInfo: data?.baseProject?.accessInfo,
    loading,
    error,
    refetch,
  };
};
